import React from "react";
import { Reveal, Label } from "@/components/Reveal";
import { LeadForm } from "@/components/LeadForm";
import { SERVICE_GROUPS, IMAGES } from "@/data/content";

const ALL_SERVICES = SERVICE_GROUPS.flatMap((g) => g.items);

export default function Book() {
  return (
    <section className="relative pt-40 pb-24 min-h-screen">
      <div className="absolute inset-0"><img src={IMAGES.salon2} alt="" className="w-full h-full object-cover opacity-15" /><div className="absolute inset-0 bg-midnight/80" /></div>
      <div className="relative max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-10">
          <Label>Reserve Your Slot</Label>
          <h1 className="text-5xl sm:text-6xl tracking-tighter mt-5">Book an Appointment</h1>
          <p className="text-white/70 mt-5">Confirmation sent to your email. Our team will call to finalise your slot.</p>
        </div>
        <Reveal>
          <LeadForm type="bookings" testid="booking-form" cta="Confirm Booking"
            extraFields={[
              { name: "service", placeholder: "Select Service", type: "select", required: true, options: ALL_SERVICES },
              { name: "date", placeholder: "Preferred Date", type: "date", required: true },
              { name: "time", placeholder: "Preferred Time", type: "time", required: true },
            ]} />
        </Reveal>
      </div>
    </section>
  );
}
